import {
  BookOpenIcon,
  ClipboardCheckIcon,
  Clock3Icon,
  FlaskConicalIcon,
  LeafIcon,
  MicroscopeIcon,
  ScanSearchIcon,
  SmilePlusIcon,
  SproutIcon,
  TargetIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '10', label: 'TOMOS COMPLETOS' },
  { value: '300+', label: 'PÁGINAS DE CURRÍCULO' },
  { value: '5', label: 'BONOS DE REGALO' },
  { value: '100%', label: 'LISTO PARA USAR' },
]

export const transformationStats: Stat[] = [
  { value: '300+', label: 'PÁGINAS LISTAS PARA ENSEÑAR' },
  { value: '5', label: 'BONOS DE REGALO' },
  { value: '100%', label: 'LISTO PARA USAR' },
]

export const beforeItems: string[] = [
  'Pasas horas buscando material en internet',
  'Improvisas la clase a último momento',
  'Armas cada examen desde cero',
  'Nunca te alcanza el tiempo',
  'Terminas agotada cada semana',
]

export const afterItems: string[] = [
  'Todo el material listo en un solo lugar',
  'Clases estructuradas y listas para dar',
  'Evaluaciones y rúbricas ya resueltas',
  'Recuperas tus tardes y fines de semana',
  'Enseñas con seguridad y confianza',
]

export interface PainPoint {
  icon: LucideIcon
  text: string
}

export const painPoints: PainPoint[] = [
  { icon: Clock3Icon, text: 'Llegas cansada a casa y todavía tienes que preparar la clase de mañana' },
  { icon: ScanSearchIcon, text: 'Buscas actividades en mil páginas y ninguna termina de servir' },
  { icon: SmilePlusIcon, text: 'Sientes que improvisas más de lo que te gustaría' },
  { icon: FlaskConicalIcon, text: 'Te encantaría enseñar con recursos de calidad, pero no tienes tiempo de crearlos' },
]

export interface KitItem {
  icon: LucideIcon
  title: string
  description: string
}

export const kitContents: KitItem[] = [
  { icon: BookOpenIcon, title: '10 Tomos Completos', description: 'Primaria (5) + Secundaria (5)' },
  { icon: LeafIcon, title: 'Más de 300 páginas', description: 'Currículo completo por nivel y tema' },
  { icon: SproutIcon, title: 'Práctica Paso a Paso', description: 'Actividades y trabajos prácticos guiados' },
  {
    icon: ClipboardCheckIcon,
    title: 'Evaluaciones y Claves de Respuestas',
    description: 'Exámenes y rúbricas listas',
  },
  { icon: MicroscopeIcon, title: 'Laboratorios y Proyectos', description: 'Prácticas seguras para el aula' },
  { icon: TargetIcon, title: 'Alineado al Currículo', description: 'Organizado por progresión pedagógica' },
]

export const instantAccessItems: string[] = [
  'Los 10 tomos completos (Primaria + Secundaria)',
  'Teoría, actividades y evaluaciones para cada tema',
  'Exámenes y rúbricas listas para imprimir',
  'Material listo para práctica guiada e independiente',
  'Todo en PDF: descargas, imprimes y enseñas',
  'Progresión clara para todo el año escolar',
]
